import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button']
  static values = { hidden: { type: Boolean, default: true } }

  connect() {
    this.boundHandleTurboStream = this.handleTurboStream.bind(this)
    document.addEventListener('turbo:before-stream-render', this.boundHandleTurboStream)
  }

  disconnect() {
    document.removeEventListener('turbo:before-stream-render', this.boundHandleTurboStream)
  }

  toggle() {
    this.hiddenValue = !this.hiddenValue
    this.updateVisibility()
    this.updateButtonText()
  }

  updateVisibility() {
    const statuses = ['completed', 'no_show', 'cancelled']
    const rows = statuses.flatMap(status =>
      [...document.querySelectorAll(`tr[data-reservation-status="${status}"]`)]
    )

    if (this.hiddenValue) {
      rows.forEach(row => {
        row.style.transition = 'opacity 0.3s ease'
        row.style.opacity = '0'
      })
      setTimeout(() => {
        rows.forEach(row => row.classList.add('d-none'))
        this.deselect(rows)
      }, 300)
    } else {
      rows.forEach(row => {
        row.classList.remove('d-none')
        row.style.opacity = '0'
      })
      requestAnimationFrame(() => {
        rows.forEach(row => {
          row.style.transition = 'opacity 0.3s ease'
          row.style.opacity = '1'
        })
      })
    }
  }

  // Clear bulk-select checkboxes on rows that just went hidden; the change
  // event lets the bulk-select controller refresh its count and select-all.
  deselect(rows) {
    rows.forEach(row => {
      const checkbox = row.querySelector('[data-bulk-select-target="checkbox"]:checked')
      if (!checkbox) return
      checkbox.checked = false
      checkbox.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updateButtonText() {
    this.buttonTarget.textContent = this.hiddenValue ? 'Show All' : 'Hide Completed'
  }

  handleTurboStream(event) {
    if (!this.hiddenValue) return

    const statuses = ['completed', 'no_show', 'cancelled']
    const fragment = event.detail.newStream.querySelector('template')?.content
    if (!fragment) return

    const row = fragment.querySelector('tr[data-reservation-status]')
    if (row && statuses.includes(row.dataset.reservationStatus)) {
      row.classList.add('d-none')
    }
  }
}
